import React, {ChangeEvent, SyntheticEvent} from "react";
import styles from "../index.module.css";
import {Button, Dropdown, DropdownProps, Form, Grid, Loader, Message, Modal, Select, TextArea} from "semantic-ui-react";
import agent from "../../../agent";
import {
    Dept,
    DeptOptions,
    Doctor,
    DoctorOptions,
    MessengerLabels,
    Patient,
    SpecialGroup,
    SpecialGroupOptions
} from "../../dashboard";
import {Redirect} from "react-router-dom";
import ReactInputMask from "react-input-mask";
import {
    AppMode,
    convertDateToMaskedDate,
    convertMaskedDateStringToDate,
    DoctorTitleCase,
    EmptyID,
    GeneralTitleCase,
    getDoctorId,
    getDoctorTitle,
    getGeneralTitle,
    getPatientTitle,
    getSpecialGroupId,
    NullDate,
    PatientTitleCase
} from "../../../utils/common";
import {DoctorPaginationResponse} from "../../workTableDoctors/DoctorsList";
import DatePicker from "react-datepicker";
import {hasRole, UserRole} from "../../../helpers/UserRole";
import {Utils} from "../../../helpers/Utils";
import {SpecialGroupPaginationResponse} from "../../workTableSpecialGroups/SpecialGroupList";
import {firstLetterToUpperCase} from "../PatientsList";
import ru from "date-fns/locale/ru";
import {
    getEducationFormLabel,
    getEducationFormsOptions,
    getFundingSourceLabel,
    getFundingSourceOptions
} from "../../../consts/tambsuConsts";
import {handleDatePickerKeyDown} from "../../../helpers/CalendarEventsRepeater";
import {textLabels} from "../../../consts/textLabels";
import {DeptPaginationResponse} from "../../workTableDepts/DeptList";
import {getPatientDeptOptions} from "../../../consts/PatientConsts";
import {validateName, validateEmail, handleOnlyEmailChars} from "../../../consts/onKeyDownValidation";
import {getDisabilityGroupFormsOptions} from "../../../consts/vladimirConsts";
import MaskedDatePicker from "../../general/MaskedDatePicker";
import {MessengerType} from "../../../@types/messengerType";
import CreatedTaskDetailsModal from "../CreatedTaskDetailsModal";
import {TaskModel} from "../../workTableTask/TaskModel";

interface ExpirationCodeResponse {
    codeexpiredat: Date,
}

interface Props {
    match?: { path: string };
    id: string;
    backUrl: string;
}

interface State {
    editable: boolean,
    _id: string,
    name: string,
    middlename: string,
    surname: string,
    tel: string,
    email: string,
    snils: string,
    registrationaddress: string,
    residenceaddress: string,
    loading: boolean,
    saved: boolean,
    prevPayload: Record<string, any> | null,
    editMode: boolean,
    dateofbirth?: Date,
    registerDate: string,
    messengerType?: MessengerType,
    codeMessenger?: MessengerType[],
    activatedDate?: Date,
    updateActivatedDate?: Date,
    activatedDateHasBeenChanged: boolean,
    openApproveChangeActivatedDateModal: boolean,
    openCancelActivationModal: boolean,
    openCancelConfirmModal: boolean,
    autoActivated?: boolean,
    diagnosis: string,
    diary?: string,
    code: number,
    codeexpiredat: Date,
    activated: boolean,
    telegramid?: string,
    vkid?: string,
    maxid?: string,
    doctorid: string,
    codeLoading: boolean,
    reactivationLoading: boolean,
    doctors: Doctor[],
    specialgroupids: string[],
    specialgroups: SpecialGroup[],
    visiblespecialgroups: boolean,
    searchSpecialGroup: string,
    patientDeptId?: string,
    patientDepts: Dept[],
    inactive: boolean,
    inactiveUntil?: Date,
    isLargeFamily?: boolean,
    inn?: string,
    botblocked?: boolean,
    telValid: boolean,
    emailValid: boolean,
    snilsValid: boolean,
    nameValid: boolean,
    surnameValid: boolean,
    middlenameValid: boolean,
    createdTask?: TaskModel,

    // для tambsu:
    institute?: string,
    specialization?: string,
    course?: string,
    educationForm?: string,
    fundingSource?: string,
    UID?: string,
    hasChildren?: boolean,
    structuralDivision?: string,
    post?: string,

    // для vladimir:
    employment?: string, // Трудоустройство
    contractTerm?: string, // Срок заключения контракта
    disabilityGroup?: string, // Группа инвалидности
}

class PatientInfoTab extends React.PureComponent<Props, State> {
    state: State = {
        editable: false,
        _id: '',
        name: '',
        middlename: '',
        surname: '',
        tel: '',
        email: '',
        snils: '',
        registrationaddress: '',
        residenceaddress: '',
        loading: false,
        saved: false,
        prevPayload: null,
        dateofbirth: undefined,
        registerDate: '',
        codeMessenger: [...window.config?.defaultMessengers ?? []],
        activatedDate: undefined,
        updateActivatedDate: undefined,
        activatedDateHasBeenChanged: false,
        openApproveChangeActivatedDateModal: false,
        openCancelActivationModal: false,
        openCancelConfirmModal: false,
        autoActivated: false,
        diagnosis: '',
        code: 0,
        codeexpiredat: new Date(0),
        activated: false,
        doctorid: '',
        codeLoading: false,
        reactivationLoading: false,
        doctors: [],
        specialgroupids: [],
        specialgroups: [],
        visiblespecialgroups: false,
        searchSpecialGroup: '',
        patientDeptId: undefined,
        patientDepts: [],
        editMode: false,
        inactive: false,
        botblocked: false,
        telValid: false,
        emailValid: true,
        snilsValid: true,
        nameValid: false,
        surnameValid: false,
        middlenameValid: true,
        createdTask: undefined,

        institute: '',
        specialization: '',
        course: '',
        educationForm: '',
        fundingSource: '',
        UID: '',
        hasChildren: false,
        structuralDivision: '',
        post: ''
    };

    clearState = (): void => {
        this.setState({
            editable: false,
            _id: '',
            name: '',
            middlename: '',
            surname: '',
            tel: '',
            email: '',
            snils: '',
            registrationaddress: '',
            residenceaddress: '',
            loading: false,
            saved: false,
            prevPayload: null,
            dateofbirth: undefined,
            registerDate: '',
            codeMessenger: [...window.config?.defaultMessengers ?? []],
            activatedDate: undefined,
            updateActivatedDate: undefined,
            activatedDateHasBeenChanged: false,
            openApproveChangeActivatedDateModal: false,
            openCancelConfirmModal: false,
            autoActivated: false,
            diagnosis: '',
            code: 0,
            codeexpiredat: new Date(0),
            activated: false,
            telegramid: undefined,
            vkid: undefined,
            maxid: undefined,
            doctorid: '',
            codeLoading: false,
            reactivationLoading: false,
            doctors: [],
            specialgroupids: [],
            specialgroups: [],
            visiblespecialgroups: false,
            searchSpecialGroup: '',
            patientDeptId: undefined,
            patientDepts: [],
            editMode: false,
            inactive: false,
            botblocked: false,
            telValid: false,
            emailValid: true,
            snilsValid: true,
            nameValid: false,
            surnameValid: false,
            middlenameValid: true,
            createdTask: undefined,

            institute: '',
            specialization: '',
            course: '',
            educationForm: '',
            fundingSource: '',
            UID: '',
            hasChildren: false,
            structuralDivision: '',
            post: ''
        })
    }

    async componentDidMount() {
        if (this.props.match && this.props.match.path.includes('edit')) {
            this.setState({ editMode: true, loading: true });
            await this.onMount();
        } else {
            this.setState({ loading: true })

            const response: DoctorPaginationResponse = await agent.DoctorProvider.getList();
            this.setState({ doctors: response.docs, loading: false, editable: true })
            const doctorId = await getDoctorId();
            if (doctorId)
                this.setState({
                    doctorid: doctorId,
                });

            const responseSp: SpecialGroupPaginationResponse = await agent.SpecialGroupProvider.getList();
            this.setState({ specialgroups: responseSp.docs, loading: false, editable: true });
            const specialGroupIds = await getSpecialGroupId();
            if (specialGroupIds)
                this.setState({
                    specialgroupids: specialGroupIds,
                });

            const responseDept: DeptPaginationResponse = await agent.DeptProvider.getList();
            this.setState({ patientDepts: responseDept.docs, loading: false, editable: true });
        }
    };

    onMount = async (): Promise<void> => {
        const patient: Patient = await agent.PatientProvider.open(this.props.id);

        if (patient) {
            this.setState({
                _id: patient._id,
                name: patient.name,
                middlename: patient.middlename,
                surname: patient.surname,
                tel: patient.tel,
                email: patient.email,
                snils: patient.snils ? patient.snils : '',
                registrationaddress: patient.registrationaddress ? patient.registrationaddress : '',
                residenceaddress: patient.residenceaddress ? patient.residenceaddress : '',
                dateofbirth: patient.dateofbirth ? patient.dateofbirth : undefined,
                registerDate: patient.registerDate ? new Date(patient.registerDate).toLocaleDateString("RU") : '',
                messengerType: this.getMessengerType(patient),
                codeMessenger: patient.codeMessenger || [],
                activatedDate: patient.activatedDate ? patient.activatedDate : undefined,
                updateActivatedDate: patient.updateActivatedDate ? patient.updateActivatedDate : undefined,
                autoActivated: patient.autoActivated,
                diagnosis: patient.diagnosis,
                diary: patient.diary,
                isLargeFamily: patient.isLargeFamily,
                code: patient.code ? patient.code : 0,
                codeexpiredat: patient.codeexpiredat ? patient.codeexpiredat : new Date(0),
                activated: patient.activated ? patient.activated : false,
                telegramid: patient.telegramid ? patient.telegramid : undefined,
                vkid: patient.vkid ? patient.vkid : undefined,
                maxid: patient.maxid ? patient.maxid : undefined,
                doctorid: patient.doctorid ? patient.doctorid : '',
                specialgroupids: patient.specialgroupids ? patient.specialgroupids : [],
                patientDeptId: patient.patientDeptId ? patient.patientDeptId : undefined,
                inactive: patient.inactive === true,
                inactiveUntil: patient.inactiveUntil ? new Date(patient.inactiveUntil!) : undefined,
                inn: patient.inn,
                botblocked: patient.botblocked === true,
                ...(window.config?.tambsu && {
                    institute: patient.institute,
                    specialization: patient.specialization,
                    course: patient.course,
                    educationForm: patient.educationForm,
                    fundingSource: patient.fundingSource,
                    UID: patient.UID,
                    hasChildren: patient.hasChildren,
                    structuralDivision: patient.structuralDivision,
                    post: patient.post
                }),
                ...(window.config?.vladimir && {
                    employment: patient.employment,
                    contractTerm: patient.contractTerm,
                    disabilityGroup: patient.disabilityGroup,
                })
            });

            const response: DoctorPaginationResponse = await agent.DoctorProvider.getList();
            this.setState({
                doctors: response.docs,
                loading: false,
            });

            const responseSp: SpecialGroupPaginationResponse = await agent.SpecialGroupProvider.getList();
            this.setState({
                specialgroups: responseSp.docs,
                loading: false,
            });

            const responseDept: DeptPaginationResponse = await agent.DeptProvider.getList();
            this.setState({
                patientDepts: responseDept.docs,
                loading: false,
            });
        }
    };

    getMessengerType = ({ telegramid, vkid, maxid } : any)  : MessengerType | undefined  => {
        return telegramid ? MessengerType.TELEGRAM :
            vkid ? MessengerType.VK :
                maxid ? MessengerType.MAX : undefined;
    };

    canEditCodeMessenger = (): boolean => {
        if (!this.state.activated) return true;
        if (this.state.code === 0) return false;
        if (!this.state.codeexpiredat) return false;

        const now = new Date();
        const expirationDate = new Date(this.state.codeexpiredat);

        return expirationDate > now; // Разрешаем редактирование если код еще не истек
    };

    cancelSave = async (): Promise<void> => {
        this.clearState();
        await this.componentDidMount()
    }

    onCreate = async (): Promise<void> => {
        this.setState({ loading: true });

        const payload = this.getPatientPayload(this.state);

        const patientId = await agent.PatientProvider.create(payload);
        this.setState({ loading: false, saved: true });
        const currentPath: string = this.props.match ? this.props.match.path.replace('/create', '') : '';
        window.location.replace(`${currentPath}/${patientId}/edit/patientInfo`);
    };

    onEdit = async () => {
        this.setState({ loading: true });

        const payload = {
            ...this.getPatientPayload(this.state),
            activatedDateHasBeenChanged: this.state.activatedDateHasBeenChanged,
        };

        await agent.PatientProvider.edit(payload).then((patient: Patient) => {
            this.setState({
                _id: patient._id,
                doctorid: patient.doctorid ? patient.doctorid : '',
                specialgroupids: patient.specialgroupids ? patient.specialgroupids : [],
                patientDeptId: patient.patientDeptId ? patient.patientDeptId : undefined,
                name: patient.name,
                middlename: patient.middlename,
                surname: patient.surname,
                tel: patient.tel,
                email: patient.email,
                snils: patient.snils ? patient.snils : '',
                registrationaddress: patient.registrationaddress ? patient.registrationaddress : '',
                residenceaddress: patient.residenceaddress ? patient.residenceaddress : '',
                dateofbirth: patient.dateofbirth,
                codeMessenger: this.state.codeMessenger || [],
                activatedDate: patient.activatedDate,
                updateActivatedDate: patient.updateActivatedDate,
                diagnosis: patient.diagnosis,
                diary: patient.diary,
                isLargeFamily: patient.isLargeFamily,
                code: patient.code ? patient.code : 0,
                inn: patient.inn,
                codeexpiredat: patient.codeexpiredat ? patient.codeexpiredat : new Date(0),
                activated: patient.activated ? patient.activated : false,
                telegramid: patient.telegramid ? patient.telegramid : undefined,
                vkid: patient.vkid ? patient.vkid : undefined,
                maxid: patient.maxid ? patient.maxid : undefined,
                ...(window.config?.tambsu && {
                    institute: this.state.institute,
                    specialization: this.state.specialization,
                    course: this.state.course,
                    educationForm: this.state.educationForm,
                    fundingSource: this.state.fundingSource,
                    UID: this.state.UID,
                    hasChildren: this.state.hasChildren,
                    structuralDivision: this.state.structuralDivision,
                    post: this.state.post
                }),
                ...(window.config?.vladimir && {
                    employment: this.state.employment,
                    contractTerm: this.state.contractTerm,
                    disabilityGroup: this.state.disabilityGroup,
                })
            });
        });

        this.setState({ loading: false, editable: false, activatedDateHasBeenChanged: false, prevPayload: null });
    };

    getDoctorsOptions = (): DoctorOptions[] => {
        return this.state.doctors.map((el: Doctor) => ({
            key: el._id,
            text: `${el.surname} ${el.name} ${el.middlename}`,
            value: el._id,
        }))
    };

    getDefaultDoctor = (): string => {
        let doctor: string = '';

        this.state.doctors && this.state.doctors.forEach((doc: Doctor) => {
            if (doc._id === this.state.doctorid) {
                doctor = `${doc.surname} ${doc.name} ${doc.middlename}`

                return
            }
        });

        return doctor;
    };

    getSelectedDoctorFullName = (): string => {
        const doctor: Doctor | undefined = this.state.doctors.find((el: Doctor) => el._id === this.state.doctorid);

        return doctor ? `${doctor.surname} ${doctor.name} ${doctor.middlename}` : '';
    };

    getSpecialGroupsOptions = (): SpecialGroupOptions[] => {
        return this.state.specialgroups.map((el: SpecialGroup) => ({
            key: el._id,
            text: `${el.name}`,
            value: el._id,
        }))
    };

    getSelectedSpecialGroups = (): string => {
        const selectedspecialgroup = this.state.specialgroups.filter(specialgroup => this.state.specialgroupids?.includes(specialgroup._id.toString()));
        return selectedspecialgroup ? selectedspecialgroup.map(specialgroup => specialgroup.name).join("; ") : '';
    };

    getSelectedPatientDepts = (): string => {
        const selectedPatientDept = this.state.patientDepts.filter(patientDept => this.state.patientDeptId?.includes(patientDept._id.toString()));
        return selectedPatientDept ? selectedPatientDept.map(patientDept => patientDept.name).join("; ") : '';
    };

    getCodeExpirationLabel = (): string => {
        const date: Date = new Date(this.state.codeexpiredat);

        if (this.state.codeexpiredat && new Date() < date) {
            return `Код активации. Истекает: ${date.toLocaleString("RU")}`
        } else {
            return `Код активации истёк`
        }
    };

    onRefreshCodeExpiration = async (): Promise<void> => {
        this.setState({ codeLoading: true });

        const response: ExpirationCodeResponse = await agent.PatientProvider.refreshCodeExpiration(this.state._id);

        if (response) {
            this.setState({ codeexpiredat: response.codeexpiredat })
        }

        this.setState({ codeLoading: false });
    };

    onReactivation = async (): Promise<void> => {
        this.setState({ reactivationLoading: true });

        try {
            const response: ExpirationCodeResponse = await agent.PatientProvider.refreshCodeExpiration(
                this.state._id
            );

            if (response) {
                this.setState({
                    codeexpiredat: response.codeexpiredat,
                    codeMessenger: this.state.codeMessenger
                });
                const responseSendReactivationMessage = await agent.PatientProvider.sendReactivationMessage(
                    this.state._id
                );

                if (responseSendReactivationMessage) {
                    this.setState({
                        code: responseSendReactivationMessage.code,
                        codeMessenger: responseSendReactivationMessage.codeMessenger
                    })
                }
            }
        } catch (error) {
            console.error('Ошибка при повторной активации:', error);
        } finally {
            this.setState({ reactivationLoading: false });
        }
    };

    onCancelActivation = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            const response = await agent.PatientProvider.cancelActivation(
                this.state._id
            );

            if (response) {
                this.setState({
                    codeexpiredat: response.codeexpiredat,
                    code: response.code,
                    codeMessenger: response.codeMessenger,
                })
            }
        } catch (error) {
            console.error('Ошибка при отмене активации:', error);
        } finally {
            this.setState({ loading: false });
        }
    }

    getPatientPayload = (state: State = this.state) => {
        return {
            _id: state._id,
            name: state.name || '',
            middlename: state.middlename || '',
            surname: state.surname || '',
            tel: state.tel || '',
            email: state.email || '',
            snils: state.snils || '',
            registrationaddress: state.registrationaddress || '',
            residenceaddress: state.residenceaddress || '',
            dateofbirth: state.dateofbirth,
            codeMessenger: (state.codeMessenger ? [...state.codeMessenger] : []).sort(),
            activatedDate: state.activatedDate,
            diagnosis: state.diagnosis || '',
            doctorid: state.doctorid ? state.doctorid : EmptyID,
            specialgroupids: (state.specialgroupids ? [...state.specialgroupids] : []).sort(),
            patientDeptId: state.patientDeptId ? state.patientDeptId : EmptyID,
            inactive: state.inactive || false,
            inactiveUntil: state.inactiveUntil,
            diary: state.diary || '',
            isLargeFamily: state.isLargeFamily || false,
            inn: state.inn || '',
            botblocked: state.botblocked || false,
            ...(window.config?.tambsu && {
                institute: state.institute || '',
                specialization: state.specialization || '',
                course: state.course || '',
                educationForm: state.educationForm || '',
                fundingSource: state.fundingSource || '',
                UID: state.UID || '',
                hasChildren: state.hasChildren || false,
                structuralDivision: state.structuralDivision || '',
                post: state.post || ''
            }),
            ...(window.config?.vladimir && {
                employment: state.employment || '',
                contractTerm: state.contractTerm || '',
                disabilityGroup: state.disabilityGroup || '',
            })
        };
    };

    hasUnsavedChanges = (): boolean => {
        if (!this.state.prevPayload) return false;

        const currentPayload = this.getPatientPayload(this.state);

        return JSON.stringify(currentPayload) !== JSON.stringify(this.state.prevPayload);
    };

    exportPatientCards = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            const task = await agent.PatientProvider.exportPatientCards([this.state._id]);
            if (task) {
                this.setState({ createdTask: task });
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({ loading: false });
        }
    };

    isSaveDisabled = (): boolean => {
        const doctorRequiredForAdmin = !this.state.editMode && hasRole(UserRole.ADMIN) && !this.state.doctorid;

        const validationFailed = !this.state.surnameValid || !this.state.nameValid || !this.state.middlenameValid || !this.state.telValid || !this.state.emailValid ||
            !(this.state.snils=='' || (this.state.snils!=='' && this.state.snilsValid)) || doctorRequiredForAdmin;

        if (validationFailed) return true;
        if (this.state.prevPayload && !this.hasUnsavedChanges()) return true;

        return false;
    };

    copyDataToClipboard = async () => {
        // Базовые данные
        let clipboardData = `${this.state.surname} ${this.state.name}${(this.state.middlename && this.state.middlename !== '') ? ' ' + this.state.middlename : ''}` +
            `${this.state.registerDate && '\nДата регистрации: ' + this.state.registerDate}` +
            `${this.state.activatedDate ? '\nДата активации: ' + new Date(this.state.activatedDate).toLocaleDateString("RU") : ''}` +
            `${this.state.dateofbirth ? '\nДата рождения: ' + convertDateToMaskedDate(new Date(this.state.dateofbirth)) : ''}` +
            `${'\nНеактивный ' + getPatientTitle(PatientTitleCase.im) + ': ' + (this.state.inactive ? 'Да' : 'Нет')}` +
            `${(this.state.inactive && this.state.inactiveUntil) ? '\nНеактивен до: ' + convertDateToMaskedDate(new Date(this.state.inactiveUntil)) : ''}` +
            `${'\nМногодетная семья: ' + (this.state.isLargeFamily ? 'Да' : 'Нет')}` +
            `${(this.state.inn && this.state.inn !== '') ? '\nИНН: ' + this.state.inn : ''}` +
            `${this.state.tel && '\nНомер телефона: ' + this.state.tel}` +
            `${(this.state.email && this.state.email !== '') ? '\nЭлектронная почта: ' + this.state.email : ''}` +
            `${(this.state.snils && this.state.snils !== '') ? '\nСНИЛС: ' + this.state.snils : ''}`+
            `${(this.state.registrationaddress && this.state.registrationaddress !== '') ? '\nАдрес регистрации: ' + this.state.registrationaddress : ''}`+
            `${(this.state.residenceaddress && this.state.residenceaddress !== '') ? '\nАдрес фактического проживания: ' + this.state.residenceaddress : ''}`+
            `${(this.state.doctorid && this.state.doctorid !== '000000000000000000000000') ? '\n' + firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im)) + ': ' + this.getSelectedDoctorFullName() : ''}` +
            `${(this.state.specialgroupids && this.getSelectedSpecialGroups() !== '') ? `\n${getGeneralTitle(GeneralTitleCase.specialgrouptab)}: ` + this.getSelectedSpecialGroups() : ''}` +
            `${(this.state.patientDeptId && this.getSelectedPatientDepts() !== '') ? `\n${firstLetterToUpperCase(getGeneralTitle(GeneralTitleCase.departmantim))} ${getPatientTitle(PatientTitleCase.a)}: ` + this.getSelectedPatientDepts() : ''}` +
            `${(this.state.diagnosis && this.state.diagnosis !== '') ? '\n' + (getGeneralTitle(GeneralTitleCase.diagnostab)) + ': ' + this.state.diagnosis : ""}` +
            `${(this.state.diary && this.state.diary !== '') ? '\nДневник: ' + this.state.diary : ''}`;

        // Данные для Тамбова
        if (window.config?.tambsu) {
            clipboardData +=
                `${(this.state.institute && this.state.institute !== '') ? '\nИнститут: ' + this.state.institute : ''}` +
                `${(this.state.specialization && this.state.specialization !== '') ? '\nСпециальность: ' + this.state.specialization : ''}` +
                `${(this.state.course && this.state.course !== '') ? '\nКурс: ' + this.state.course : ''}` +
                `${(this.state.educationForm && this.state.educationForm !== '') ? '\nФорма обучения: ' + getEducationFormLabel(this.state.educationForm) : ''}` +
                `${(this.state.fundingSource && this.state.fundingSource !== '') ? '\nИсточник финансирования: ' + getFundingSourceLabel(this.state.fundingSource) : ''}` +
                `${(this.state.UID && this.state.UID !== '') ? '\nУИД: ' + this.state.UID : ''}` +
                `${'\nНаличие детей: ' + (this.state.hasChildren ? 'Да' : 'Нет')}` +
                `${(this.state.structuralDivision && this.state.structuralDivision !== '') ? '\nСтруктурное подразделение: ' + this.state.structuralDivision : ''}` +
                `${(this.state.post && this.state.post !== '') ? '\nДолжность: ' + this.state.post : ''}`;
        }

        // Данные для Владимира
        if (window.config?.vladimir) {
            clipboardData +=
                `${(this.state.employment && this.state.employment !== '') ? '\nТрудоустройство: ' + this.state.employment : ''}` +
                `${(this.state.contractTerm && this.state.contractTerm !== '') ? '\nСрок заключения контракта: ' + this.state.contractTerm : ''}` +
                `${(this.state.disabilityGroup && this.state.disabilityGroup !== '') ? '\nГруппа инвалидности: ' + this.state.disabilityGroup : ''}`;
        }

        try {
            // Современный метод с Clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(clipboardData);
                console.log('Данные скопированы в буфер обмена (Clipboard API)');
            } else {
                // Старый метод для совместимости
                this.fallbackCopyToClipboard(clipboardData);
            }
        } catch (error) {
            console.error('Ошибка при копировании в буфер обмена:', error);
            this.fallbackCopyToClipboard(clipboardData);
        }
    }

    // Резервный метод для старых браузеров для копирования в буфер обмен
    fallbackCopyToClipboard = (text: string) => {
        const el = document.createElement('textarea');
        el.value = text;
        el.style.display = 'hidden';
        document.body.appendChild(el);

        try {
            el.select();
            const successful = document.execCommand('copy');
            if (successful) {
                console.log('Данные скопированы в буфер обмена (fallback method)');
            } else {
                console.error('Не удалось скопировать данные (fallback method)');
            }
        } catch (err) {
            console.error('Ошибка при использовании fallback метода:', err);
        } finally {
            document.body.removeChild(el);
        }
    }

    render() {
        const NilObjectId: string = '000000000000000000000000';

        return (
            this.state.saved ?
                <Redirect to={'/dashboard/patients'} />
                :
                <div className={this.state.editMode ? styles.patientInfoContent : styles.patientCreating}>
                    {this.state.createdTask && <CreatedTaskDetailsModal task={this.state.createdTask} onClose={() => this.setState({ createdTask: undefined })} />}
                    {
                        this.state.editMode ? ''
                            :
                            <div className={styles.patientInfoHeader}>
                                Создание {getPatientTitle(PatientTitleCase.a)}
                            </div>

                    }
                    {
                        this.state.loading ?
                            <Loader active>Список загружается...</Loader>
                            :
                            <Form>
                                {
                                    this.state.openApproveChangeActivatedDateModal &&
                                    <Modal
                                        onClose={() => this.setState({openApproveChangeActivatedDateModal: false})}
                                        open={this.state.openApproveChangeActivatedDateModal}
                                        closeIcon
                                    >
                                        <Modal.Header>Изменение даты активации</Modal.Header>
                                        <Modal.Content>Вы изменили дату активации. Вы уверены, что хотите сохранить новые данные, в том числе дату активации?</Modal.Content>
                                        <Modal.Actions>
                                            <Button
                                                content={'Да, сохранить'}
                                                onClick={() => {
                                                    this.state.editMode ? this.onEdit() : this.onCreate();
                                                    this.setState({openApproveChangeActivatedDateModal: false});
                                                }}
                                                positive
                                            />
                                            <Button
                                                content={'Нет, не сохранять'}
                                                onClick={() => {
                                                    this.cancelSave();
                                                    this.setState({openApproveChangeActivatedDateModal: false});
                                                }}
                                                negative
                                            />
                                            <Button
                                                color={'grey'}
                                                onClick={() => this.setState({openApproveChangeActivatedDateModal: false})}
                                            >
                                                {textLabels.cancelButton}
                                            </Button>
                                        </Modal.Actions>
                                    </Modal>
                                }
                                {
                                    this.state.openCancelActivationModal &&
                                    <Modal
                                        size="mini"
                                        open={this.state.openCancelActivationModal}
                                        onClose={() => this.setState({openCancelActivationModal: false})}
                                    >
                                        <Modal.Header>Подтвердите отмену</Modal.Header>
                                        <Modal.Content>Вы уверены, что хотите отменить активацию?</Modal.Content>
                                        <Modal.Actions>
                                            <Button negative onClick={async () => {
                                                this.setState({openCancelActivationModal: false});
                                                await this.onCancelActivation();
                                            }}>
                                                OK
                                            </Button>
                                            <Button onClick={() => this.setState({openCancelActivationModal: false})} color="grey">Отмена</Button>
                                        </Modal.Actions>
                                    </Modal>
                                }
                                <Grid stackable columns={4} stretched>
                                    <Grid.Column>
                                            {
                                                this.state.editable ?
                                                    <Button
                                                        color={'green'}
                                                        type={'submit'}
                                                        content={textLabels.saveButton}
                                                        disabled={this.isSaveDisabled()}
                                                        onClick={this.state.activatedDateHasBeenChanged
                                                            ? () => this.setState({openApproveChangeActivatedDateModal: true})
                                                            : (this.state.editMode ? this.onEdit : this.onCreate)}
                                                    />
                                                    :
                                                    <Button
                                                        color={'teal'}
                                                        type={'submit'}
                                                        content={textLabels.editButton}
                                                        disabled={hasRole(UserRole.OBSERVER)}
                                                        onClick={() => this.setState((currentState) => ({
                                                            editable: true,
                                                            telValid: true,
                                                            nameValid: true,
                                                            surnameValid: true,
                                                            prevPayload: this.getPatientPayload(currentState),
                                                        }))}
                                                    />
                                            }
                                        </Grid.Column>
                                        <Grid.Column>
                                            {this.state.editable && this.state.editMode ?
                                                <Button
                                                    color={'grey'}
                                                    content={textLabels.cancelButton}
                                                    onClick={() => {
                                                        if (this.hasUnsavedChanges()) {
                                                            this.setState({ openCancelConfirmModal: true });
                                                        } else {
                                                            this.cancelSave();
                                                        }
                                                    }}
                                                />
                                                :
                                                <Button.Group>
                                                    <Button
                                                        color={'violet'}
                                                        basic
                                                        content={'Копировать данные'}
                                                        disabled={hasRole(UserRole.OBSERVER)}
                                                        onClick={this.copyDataToClipboard}
                                                    />
                                                    {this.state.editMode &&
                                                        <Button
                                                            color={'violet'}
                                                            basic
                                                            content={'Скачать'}
                                                            disabled={hasRole(UserRole.OBSERVER)}
                                                            onClick={this.exportPatientCards}
                                                        />
                                                    }
                                                </Button.Group>
                                            }
                                        </Grid.Column>
                                        {this.state.openCancelConfirmModal &&
                                            <Modal
                                                size="small"
                                                open={this.state.openCancelConfirmModal}
                                                onClose={() => this.setState({ openCancelConfirmModal: false })}
                                                closeIcon
                                            >
                                                <Modal.Header>Отмена изменений</Modal.Header>
                                                <Modal.Content>Вы уверены, что хотите отменить внесённые изменения? Все несохранённые данные будут потеряны.</Modal.Content>
                                                <Modal.Actions>
                                                    <Button
                                                        negative
                                                        content={'Да, отменить'}
                                                        onClick={() => {
                                                            this.setState({ openCancelConfirmModal: false });
                                                            this.cancelSave();
                                                        }}
                                                    />
                                                    <Button
                                                        color={'grey'}
                                                        content={'Нет, продолжить редактирование'}
                                                        onClick={() => this.setState({ openCancelConfirmModal: false })}
                                                    />
                                                </Modal.Actions>
                                            </Modal>
                                        }
                                {
                                        this.state.editMode ?

                                            <Grid.Column>
                                                <div className={styles.codeInfo}>
                                                    {
                                                        this.state.activated &&
                                                            <Message
                                                                size={'mini'}
                                                                header={Utils.vomode()!=AppMode.PATIENT ?
                                                                    `Бот активирован${this.state.messengerType ? ` (${MessengerLabels[this.state.messengerType]})` : ''}` :
                                                                    `Пациент активирован${this.state.messengerType ? ` (${MessengerLabels[this.state.messengerType]})` : ''}`}
                                                            />
                                                    }
                                                    {
                                                        this.canEditCodeMessenger() &&
                                                            <>
                                                                    <Form.Input label={this.getCodeExpirationLabel()}
                                                                                value={this.state.code}
                                                                                readOnly
                                                                                action={this.state.activated && hasRole(UserRole.ADMIN, UserRole.DOCTOR) && {
                                                                                    icon: "close",
                                                                                    onClick: () => {
                                                                                        this.setState({ openCancelActivationModal: true });
                                                                                    }
                                                                                }}
                                                                    />
                                                                    <Form.Button floated={'left'}
                                                                                 color={'blue'}
                                                                                 fluid
                                                                                 loading={this.state.codeLoading}
                                                                                 disabled={hasRole(UserRole.OBSERVER)}
                                                                                 onClick={this.onRefreshCodeExpiration}>
                                                                        Продлить срок действия кода
                                                                    </Form.Button>
                                                                </>
                                                    }
                                                </div>
                                            </Grid.Column>
                                            :
                                            ''
                                    }
                                    {
                                        this.state.editMode && this.canEditCodeMessenger() ?
                                        <Grid.Column>
                                            <Form.Field>
                                                <label>Мессенджер кода активации</label>
                                                <div className={styles.special_group_area}>
                                                    {[...window.config?.availableMessengers ?? []].map((messenger: MessengerType) => {
                                                        const isCurrentActive: boolean = messenger === this.getMessengerType(this.state);

                                                        return (
                                                            <label key={messenger} style={{ display: 'flex', alignItems: 'center', fontWeight: 400, marginBottom: '8px' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    value={messenger}
                                                                    checked={this.state.codeMessenger?.includes(messenger) || false}
                                                                    disabled={!this.state.editable || !this.canEditCodeMessenger()}
                                                                    style={{ marginRight: '5px' }}
                                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                                        const { value, checked } = e.target;
                                                                        this.setState((prevState) => {
                                                                            const currentMessengers = prevState.codeMessenger || [];

                                                                            if (checked) {
                                                                                return { codeMessenger: [...currentMessengers, value] as  MessengerType[] };
                                                                            } else {
                                                                                return {
                                                                                    codeMessenger: currentMessengers.filter(
                                                                                        (messenger) => messenger !== value
                                                                                    ),
                                                                                };
                                                                            }
                                                                        });
                                                                    }}
                                                                />
                                                                {MessengerLabels[messenger]}
                                                                {isCurrentActive && <span style={{ marginLeft: '5px', color: 'green', fontSize: '12px' }}>(активирован)</span>}
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            </Form.Field>
                                        </Grid.Column>
                                        : this.state.activated && <Grid.Column>
                                                <Button
                                                    color={'blue'}
                                                    basic
                                                    content={'Повторная активация'}
                                                    disabled={!hasRole(UserRole.ADMIN, UserRole.DOCTOR)}
                                                    loading={this.state.reactivationLoading}
                                                    onClick={this.onReactivation}
                                                />
                                        </Grid.Column>
                                    }
                                </Grid>
                                <Grid stackable columns={5} stretched>
                                    <Grid.Column>
                                        <Form.Field>
                                            <label>Неактивный {getPatientTitle(PatientTitleCase.im)}</label>
                                            <Form.Checkbox
                                                checked={this.state.inactive}
                                                readOnly={!this.state.editable}
                                                toggle
                                                onChange={(event, data) =>
                                                    this.setState({
                                                        inactive: data.checked === true,
                                                        inactiveUntil: data.checked ?
                                                            this.state.inactiveUntil : undefined
                                                    })} />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field disabled={!this.state.inactive}>
                                            <label>Неактивен до</label>
                                            <MaskedDatePicker
                                                selected={this.state.inactiveUntil}
                                                readOnly={!this.state.editable}
                                                disabled={!this.state.inactive}
                                                onChange={(v?: Date) => {
                                                    this.setState({
                                                        inactiveUntil: v
                                                    })
                                                }}
                                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                                onKeyDown={handleDatePickerKeyDown}
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field>
                                            <label>Многодетная семья</label>
                                            <Form.Checkbox
                                                checked={this.state.isLargeFamily}
                                                readOnly={!this.state.editable}
                                                toggle
                                                fitted

                                                onChange={(event, data) =>
                                                    this.setState({
                                                        isLargeFamily: data.checked === true
                                                    })} />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column width={2}>
                                        <Form.Field disabled={this.state.editable}>
                                            <label>Дата регистрации</label>
                                            <ReactInputMask
                                                mask={'99.99.9999'}
                                                alwaysShowMask={false}
                                                value={this.state.registerDate}
                                                readOnly={true}
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column width={'4'}>
                                        <Form.Field disabled={!this.state.editMode || (this.state.editable && ((this.state.autoActivated && this.state.activatedDate!==undefined && this.state.activatedDateHasBeenChanged===false) || !this.state.activated))}>
                                            <label>Дата активации{(this.state.updateActivatedDate===undefined) ? '' : ` (обновлено: ${new Date(this.state.updateActivatedDate).toLocaleDateString("RU")})`}</label>
                                            <MaskedDatePicker
                                                selected={this.state.activatedDate ? new Date(this.state.activatedDate) : null}
                                                onChange={(date?: Date) => {
                                                    this.setState({
                                                        activatedDate: date,
                                                        activatedDateHasBeenChanged: true
                                                    });
                                                }}
                                                onKeyDown={handleDatePickerKeyDown}
                                                maxDate={new Date()}
                                                minDate={this.state.registerDate ? convertMaskedDateStringToDate(this.state.registerDate) : undefined}
                                                readOnly={!this.state.editable || (this.state.autoActivated && this.state.activatedDate!==undefined && this.state.activatedDateHasBeenChanged===false)}
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    {window.config?.moniki == true && hasRole(UserRole.ADMIN) &&
                                        <Grid.Column>
                                            <Form.Field>
                                                <label>Бот заблокирован</label>
                                                <Form.Checkbox
                                                    checked={this.state.botblocked}
                                                    readOnly={!this.state.editable}
                                                    toggle
                                                    onChange={(event, data) =>
                                                        this.setState({
                                                            botblocked: data.checked === true
                                                        })} />
                                            </Form.Field>

                                        </Grid.Column>}

                                </Grid>

                                <Form.Group widths={"equal"}>
                                    <Form.Input label={'Фамилия'}
                                        fluid
                                        value={this.state.surname}
                                        required={true}
                                        readOnly={!this.state.editable}
                                        onChange={(e) => {
                                            const { filteredValue, isValid } = validateName(e.target.value);
                                            this.setState({
                                                surname: filteredValue,
                                                surnameValid: isValid,
                                            });
                                        }}
                                        error={!this.state.surnameValid && this.state.editable}
                                        content={!this.state.surnameValid && this.state.surname !== '' && "Требуется длина от 2 букв"}
                                    />
                                    <Form.Input label={'Имя'}
                                        required={true}
                                        value={this.state.name}
                                        readOnly={!this.state.editable}
                                        onChange={(e) => {
                                            const { filteredValue, isValid } = validateName(e.target.value);
                                            this.setState({
                                                name: filteredValue,
                                                nameValid: isValid,
                                            });
                                        }}
                                        error={!this.state.nameValid && this.state.editable}
                                        content={!this.state.nameValid && this.state.name !== '' && "Требуется длина от 2 букв"}
                                    />
                                    <Form.Input label={'Отчество'}
                                        value={this.state.middlename}
                                        readOnly={!this.state.editable}
                                        onChange={(e) => {
                                            const { filteredValue, isValid } = validateName(e.target.value, false);
                                            this.setState({
                                                middlename: filteredValue,
                                                middlenameValid: isValid,
                                            });
                                        }}
                                        error={!this.state.middlenameValid && this.state.editable}
                                        content={!this.state.middlenameValid && this.state.middlename !== '' && "Требуется длина от 2 букв"}
                                    />
                                </Form.Group>
                                <Form.Group widths={"equal"}>
                                    <Form.Field>
                                        <label>Дата рождения</label>
                                        <MaskedDatePicker
                                            selected={this.state.dateofbirth ? new Date(this.state.dateofbirth) : null}
                                            onChange={(date?: Date) => {
                                                this.setState({
                                                    dateofbirth: date
                                                });
                                            }}
                                            onKeyDown={handleDatePickerKeyDown}
                                            minDate={new Date('1900-01-01')}
                                            maxDate={new Date()}
                                            readOnly={!this.state.editable}
                                        />
                                    </Form.Field>
                                    {Utils.vomode()!=AppMode.PATIENT &&
                                        <Form.Input label={'ИНН'}
                                            value={this.state.inn}
                                            readOnly={!this.state.editable}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ inn: e.target.value })}
                                        />}
                                    <Form.Input
                                        label="Номер телефона"
                                        value={this.state.tel}
                                        required={true}
                                        readOnly={!this.state.editable}
                                        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                                            if (e.target.value.length < 1) {
                                                this.setState({ tel: '+7' + this.state.tel });
                                            }
                                        }}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            const inputValue = e.target.value;
                                            const isNonEmpty = inputValue.trim() !== '';
                                            const filteredValue = isNonEmpty ? inputValue.replace(/[^0-9+]/g, '') : '';
                                            const filteredValueInt = isNonEmpty ? inputValue.replace(/[^0-9]/g, '') : '';
                                            const filteredValuePlus = isNonEmpty ? inputValue.replace(/[^+]/g, '') : '';
                                            const lengthInt = filteredValueInt.length;
                                            const lengthPlus = filteredValuePlus.length;
                                            const isValid = isNonEmpty ? (lengthInt >= 7 && lengthInt <= 11 && lengthPlus <= 1) : false;
                                            this.setState({
                                                tel: filteredValue,
                                                telValid: isValid,
                                            });
                                        }}
                                        error={!this.state.telValid && this.state.editable}
                                        content={!this.state.telValid && this.state.tel !== '' && "Требуется длина от 7 до 11 цифр"}
                                    />
                                    <Form.Input
                                        //Проверка на @, точку и по хотя бы одному англ символу и цифр между
                                        label="Электронная почта"
                                        value={this.state.email}
                                        type="email"
                                        readOnly={!this.state.editable}
                                        onKeyDown={handleOnlyEmailChars}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            const { filteredValue, isValid } = validateEmail(e.target.value);

                                            this.setState({
                                                email: filteredValue,
                                                emailValid: isValid,
                                            });
                                        }}
                                        error={!this.state.emailValid}
                                        content={!this.state.emailValid && "Введите правильный адрес электронной почты"}
                                    />
                                </Form.Group>
                                <Form.Group widths={"equal"}>
                                    <Form.Field>
                                        <label>СНИЛС</label>
                                        <ReactInputMask
                                            mask={'999-999-999 99'}
                                            alwaysShowMask={false}
                                            value={this.state.snils}
                                            readOnly={!this.state.editable}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                const inputValue = e.target.value;
                                                const isValid = /^\d{3}-\d{3}-\d{3} \d{2}$/.test(inputValue);
                                                this.setState({ snils: inputValue, snilsValid: isValid})
                                                }
                                            }
                                            style={{ border: (this.state.snilsValid || (!this.state.snilsValid && this.state.snils=='')) ? '' : '1px solid red' }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Адрес регистрации</label>
                                        <Form.Input as={TextArea}
                                            value={this.state.registrationaddress}
                                            readOnly={!this.state.editable}
                                            maxLength={1000}
                                            rows={1}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                const inputValue = e.target.value;
                                                this.setState({
                                                    registrationaddress: inputValue,
                                                });
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Адрес фактического проживания</label>
                                        <Form.Input as={TextArea}
                                            value={this.state.residenceaddress}
                                            readOnly={!this.state.editable}
                                            maxLength={1000}
                                            rows={1}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                const inputValue = e.target.value;
                                                this.setState({
                                                    residenceaddress: inputValue,
                                                });
                                            }}
                                        />
                                        </Form.Field>
                                </Form.Group>

                                <Form.Group widths={"equal"}>
                                    {
                                        this.state.editable ?
                                            <>
                                                <Form.Field
                                                    required={!this.state.editMode && hasRole(UserRole.ADMIN)}
                                                    error={!this.state.editMode && hasRole(UserRole.ADMIN) && !this.state.doctorid && this.state.editable}
                                                >
                                                    <label>{firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im))}</label>
                                                    <Dropdown
                                                        placeholder={(this.state.doctorid && this.state.doctorid !== NilObjectId) ? this.getDefaultDoctor() :
                                                            `Выберите ${getDoctorTitle(DoctorTitleCase.a)}`}
                                                        search
                                                        selection
                                                        clearable={!this.state.editMode}
                                                        disabled={!this.state.editable || !hasRole(UserRole.ADMIN)}
                                                        options={this.getDoctorsOptions()}
                                                        onChange={(e, data) =>
                                                            this.setState({
                                                                doctorid: data.value as string,
                                                                patientDeptId: undefined
                                                            })
                                                        }
                                                        noResultsMessage={textLabels.noResultsMessage}
                                                    />
                                                </Form.Field>
                                                <Form.Field>
                                                    <label>{`${firstLetterToUpperCase(getGeneralTitle(GeneralTitleCase.departmantim))} ${getPatientTitle(PatientTitleCase.a)}`}</label>
                                                    <Select
                                                        key={this.state.patientDeptId}
                                                        search={true}
                                                        value={this.state.patientDeptId}
                                                        options={getPatientDeptOptions(
                                                            this.state.doctors,
                                                            this.state.doctorid,
                                                            this.state.patientDepts
                                                        ).map((option) => ({
                                                            value: option.value,
                                                            text: option.text,
                                                        }))}
                                                        onChange={(e, { value }) => {
                                                            if (value !== undefined) {
                                                                this.setState({ patientDeptId: value as string });
                                                            }
                                                        }}
                                                        disabled={!this.state.editable || !this.state.doctorid}
                                                        noResultsMessage={textLabels.noResultsMessage}
                                                    />
                                                </Form.Field>
                                            </>
                                            :
                                            <>
                                                <Form.Input label={firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im))}
                                                value={this.getSelectedDoctorFullName()}
                                                readOnly />
                                                <Form.Input label={`${firstLetterToUpperCase(getGeneralTitle(GeneralTitleCase.departmantim))} ${getPatientTitle(PatientTitleCase.a)}`}
                                                            value={this.getSelectedPatientDepts()}
                                                            readOnly />
                                            </>

                                    }
                                </Form.Group>

                                {
                                    this.state.editable ?
                                        <div>
                                            <button type="button" onClick={() => this.setState({ visiblespecialgroups: !this.state.visiblespecialgroups })}
                                                style={{ background: 'white', border: "1px solid gray", borderRadius: '3px', margin: '0 0 5px 0', padding: '5px' }}
                                            >
                                                {this.state.visiblespecialgroups ? "Скрыть" : "Показать"} {getGeneralTitle(GeneralTitleCase.specialgrouptab)}
                                            </button>
                                            {this.state.visiblespecialgroups && (
                                                <Form.Field>
                                                    <label>{getGeneralTitle(GeneralTitleCase.specialgrouptab)}</label>
                                                    <div className={styles.special_group_area}>
                                                        <div className={styles.special_group_search}>
                                                            <input
                                                                type="text"
                                                                value={this.state.searchSpecialGroup}
                                                                onChange={(e) => this.setState({ searchSpecialGroup: e.target.value })}
                                                                placeholder="Поиск"
                                                                style={{ width: '30%' }}
                                                            />
                                                            <Button basic color='orange' content='Сбросить'
                                                                onClick={() => this.setState({ searchSpecialGroup: '' })}
                                                                style={{ marginLeft: '10px' }}
                                                            />
                                                        </div>
                                                        {this.getSpecialGroupsOptions()
                                                            .filter((option) => option.text.toLowerCase().includes(this.state.searchSpecialGroup.toLowerCase()))
                                                            .sort((a, b) => a.text.localeCompare(b.text))
                                                            .map((option) => (
                                                            <label key={option.value} style={{ display: 'flex', alignItems: 'center', fontWeight: 400 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    value={option.value}
                                                                    checked={this.state.specialgroupids.includes(option.value)}
                                                                    style={{ marginRight: '5px' }}
                                                                    disabled={!this.state.editable}
                                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                                        const { value, checked } = e.target;
                                                                        this.setState((prevState) => {
                                                                            if (checked) {
                                                                                return { specialgroupids: [...prevState.specialgroupids, value] };
                                                                            } else {
                                                                                return {
                                                                                    specialgroupids: prevState.specialgroupids.filter(
                                                                                        (id) => id !== value
                                                                                    ),
                                                                                };
                                                                            }
                                                                        });
                                                                    }}
                                                                />
                                                                {option.text}
                                                            </label>
                                                        ))}
                                                    </div>
                                                    {/*<select*/}
                                                    {/*    className={styles.select_multiple}*/}
                                                    {/*    multiple={true}*/}
                                                    {/*    value={this.state.specialgroupids}*/}
                                                    {/*    onChange={(e) => this.setState({ specialgroupids: Array.from(e.target.selectedOptions, (option) => option.value) })}*/}
                                                    {/*    disabled={!this.state.editable}*/}
                                                    {/*>*/}
                                                    {/*    {this.getSpecialGroupsOptions().map((option) => (*/}
                                                    {/*        <option key={option.value} value={option.value}>{option.text}</option>*/}
                                                    {/*    ))}*/}
                                                    {/*</select>*/}
                                                </Form.Field>)}
                                        </div>
                                        :
                                        <Form.Field>
                                            <label>{getGeneralTitle(GeneralTitleCase.specialgrouptab)}</label>
                                            <Form.Input
                                                as={TextArea}
                                                control={'string'}
                                                rows={1}
                                                value={this.getSelectedSpecialGroups()}
                                                readOnly
                                            />
                                        </Form.Field>
                                }

                                <Form.Field>
                                    <label>{getGeneralTitle(GeneralTitleCase.diagnostab)}</label>
                                    <Form.Input as={TextArea}
                                        control={'string'}
                                        rows={2}
                                        value={this.state.diagnosis}
                                        readOnly={!this.state.editable}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ diagnosis: e.target.value })}
                                    />
                                </Form.Field>

                                {window.config?.tambsu &&
                                    <>
                                        <Form.Group widths={"equal"}>
                                            <Form.Input
                                                label="Институт"
                                                value={this.state.institute}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ institute: e.target.value })}
                                            />
                                            <Form.Input
                                                label="Специальность"
                                                value={this.state.specialization}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ specialization: e.target.value })}
                                            />
                                            <Form.Input
                                                label="Курс"
                                                value={this.state.course}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ course: e.target.value })}
                                            />
                                            <Form.Field>
                                                <label>Форма обучения</label>
                                                <Dropdown
                                                    disabled={!this.state.editable}
                                                    placeholder={this.state.editable ? 'Выберите форму обучения' : ''}
                                                    selection
                                                    clearable
                                                    options={getEducationFormsOptions()}
                                                    defaultValue={this.state.educationForm}
                                                    onChange={(e: SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                                        this.setState({
                                                            educationForm: data.value as string
                                                        })
                                                    }}
                                                />
                                            </Form.Field>
                                            <Form.Field>
                                                <label>Источник финансирования</label>
                                                <Dropdown
                                                    disabled={!this.state.editable}
                                                    placeholder={this.state.editable ? 'Выберите источник' : ''}
                                                    selection
                                                    clearable
                                                    options={getFundingSourceOptions()}
                                                    defaultValue={this.state.fundingSource}
                                                    onChange={(e: SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                                        this.setState({
                                                            fundingSource: data.value as string
                                                        })
                                                    }}
                                                />
                                            </Form.Field>
                                        </Form.Group>
                                        <Form.Group widths={"equal"}>
                                            <Form.Input
                                                label="УИД"
                                                value={this.state.UID}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ UID: e.target.value })}
                                            />
                                            <Form.Field width={4}>
                                                <label>Наличие детей</label>
                                                <Form.Checkbox
                                                    checked={this.state.hasChildren}
                                                    readOnly={!this.state.editable}
                                                    toggle
                                                    fitted
                                                    onChange={(event, data) =>
                                                        this.setState({
                                                            hasChildren: data.checked === true
                                                        })} />
                                            </Form.Field>
                                            <Form.Input
                                                label="Структурное подразделение"
                                                value={this.state.structuralDivision}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ structuralDivision: e.target.value })}
                                            />
                                            <Form.Input
                                                label="Должность"
                                                value={this.state.post}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ post: e.target.value })}
                                            />
                                        </Form.Group>
                                    </>
                                }

                                {window.config?.vladimir &&
                                    <>
                                        <Form.Group widths={"equal"}>
                                            <Form.Input
                                                label="Трудоустройство"
                                                value={this.state.employment}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ employment: e.target.value })}
                                            />
                                            <Form.Input
                                                label="Срок заключения контракта"
                                                value={this.state.contractTerm}
                                                readOnly={!this.state.editable}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ contractTerm: e.target.value })}
                                            />
                                            <Form.Field>
                                                <label>Группа инвалидности</label>
                                                <Dropdown
                                                    disabled={!this.state.editable}
                                                    placeholder={this.state.editable ? 'Выберите группу инвалидности' : ''}
                                                    selection
                                                    clearable
                                                    options={getDisabilityGroupFormsOptions()}
                                                    defaultValue={this.state.disabilityGroup}
                                                    onChange={(e: SyntheticEvent<HTMLElement>, data: DropdownProps) => {
                                                        this.setState({
                                                            disabilityGroup: data.value as string
                                                        })
                                                    }}
                                                />
                                            </Form.Field>
                                        </Form.Group>
                                    </>
                                }

                                <Form.Field>
                                    <label>Дневник</label>
                                    <Form.Input as={TextArea}
                                        control={'string'}
                                        rows={16}
                                        value={this.state.diary}
                                        readOnly={!this.state.editable}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => this.setState({ diary: e.target.value })}
                                    />

                                </Form.Field>

                            </Form>
                    }
                </div>
        )
    }

}

export default PatientInfoTab;